export const messages = {
  en: {
    maintainanceStandardItem: {
      title: 'Inspection Items',
      back: 'Back',
      add: 'Add',
      item: 'Inspection Item',
      id: 'ID',
      operation: 'Operation',
      delete: 'Delete',
      fetchError: 'Failed to fetch inspection items'
    },
    chooseMaintainanceStandardItem: {
      title: 'Select Inspection Items',
      searchPlaceholder: 'Enter inspection item',
      search: 'Search',
      reset: 'Reset',
      id: 'ID',
      item: 'Inspection Item',
      submit: 'Submit',
      cancel: 'Cancel',
      selectWarning: 'Please select at least one inspection item',
      submitSuccess: 'Added successfully',
      submitError: 'Failed to add inspection items',
      fetchError: 'Failed to fetch available inspection items'
    },
    deleteMaintainanceStandardItem: {
      title: 'Confirm Operation',
      confirmMessage: 'Are you sure to delete this inspection item?',
      cancel: 'Cancel',
      confirm: 'Confirm Delete',
      deleteSuccess: 'Deleted successfully',
      deleteError: 'Failed to delete inspection item'
    }
  },
  zh: {
    maintainanceStandardItem: {
      title: '检查项',
      back: '返回',
      add: '添加',
      item: '检查项',
      id: '编号',
      operation: '操作',
      delete: '删除',
      fetchError: '获取检查项失败'
    },
    chooseMaintainanceStandardItem: {
      title: '选择检查项',
      searchPlaceholder: '输入检查项',
      search: '查询',
      reset: '重置',
      id: '编号',
      item: '检查项',
      submit: '提交',
      cancel: '取消',
      selectWarning: '请至少选择一项检查项',
      submitSuccess: '添加成功',
      submitError: '添加检查项失败',
      fetchError: '获取可选检查项失败'
    },
    deleteMaintainanceStandardItem: {
      title: '请确认您的操作',
      confirmMessage: '确定删除该检查项吗？',
      cancel: '点错了',
      confirm: '确认删除',
      deleteSuccess: '删除成功',
deleteError: '删除检查项失败'
    }
  },
  'zh-TW': {
    maintainanceStandardItem: {
      title: '檢查項',
      back: '返回',
      add: '添加',
      item: '檢查項',
      id: '編號',
      operation: '操作',
      delete: '刪除',
      fetchError: '獲取檢查項失敗'
    },
    chooseMaintainanceStandardItem: {
      title: '選擇檢查項',
      searchPlaceholder: '輸入檢查項',
      search: '查詢',
      reset: '重設',
      id: '編號',
      item: '檢查項',
      submit: '提交',
      cancel: '取消',
      selectWarning: '請至少選擇一項檢查項',
      submitSuccess: '添加成功',
      submitError: '添加檢查項失敗',
      fetchError: '獲取可選檢查項失敗'
    },
    deleteMaintainanceStandardItem: {
      title: '確認操作',
      confirmMessage: '確定刪除該檢查項嗎？',
      cancel: '取消',
      confirm: '確認刪除',
      deleteSuccess: '刪除成功',
      deleteError: '刪除檢查項失敗'
    }
  }
}